<div class="row mt-5">
    <div class="col-12" style="padding-right: 0 !important; margin-right: 0 !important">
      <div class="card">
        <div class="card-body">
          <ng-container *ngIf="displayLoader">
            <div class="loader-container" style="width: 55%">
              <ng-container *ngFor="let i of [1,2,3,4,5,6,7]">
                <li class="t_loader">
                  <div class="card__desc load" [id]="i % 2 === 0 ? '' : 'long'"></div>
                </li>
              </ng-container>
            </div>
          </ng-container>
          
          <div *ngIf="!displayLoader">
            <div class="job-dropdown mb-3">
              <label for="jobTitleSelect">Job Title</label>
              <select id="jobTitleSelect" [(ngModel)]="selectedJobId" class="form-control">
                  <option *ngFor="let job of jobOptions" [ngValue]="job.jobOrderId">
                      {{ job.jobOrderTitle }}
                  </option>
              </select>
            </div>

            <div class="table-responsive">
              <table *ngIf="selectedCandidates.length > 0; else noCandidates" class="table mb-2">
                <thead>
                  <tr>
                    
                    <th scope="col">
                        <div class="flex-container" (click)="sort('firstName')">
                           Name <span ><i class="fa fa-sort"></i></span>
                        </div>
                      </th>
                    <th scope="col">
                       <div class="flex-container" (click)="sort('nickName')">
                           Preferred Name <span ><i class="fa fa-sort"></i></span>
                        </div>
                      </th>
                    <th scope="col">
                       <div class="flex-container" (click)="sort('gender')">
                           Gender <span ><i class="fa fa-sort"></i></span>
                        </div>
                      </th>
                    <th scope="col">
                      <div class="flex-container" (click)="sort('mobile')">
                           Mobile <span ><i class="fa fa-sort"></i></span>
                        </div>
                    </th>
                    <th scope="col">
                      <div class="flex-container" (click)="sort('email')">
                           Email <span ><i class="fa fa-sort"></i></span>
                        </div>
                    </th>
                    <th scope="col">
                      <div class="flex-container" (click)="sort('customText20')">
                           Work Authority <span ><i class="fa fa-sort"></i></span>
                        </div>
                    </th>
                    <th scope="col">
                      <div class="flex-container" (click)="sort('customDate1')">
                           Expiry Date <span ><i class="fa fa-sort"></i></span>
                        </div>
                    </th>
                    <th scope="col">
                      <div class="flex-container" (click)="sort('status')">
                           Status <span ><i class="fa fa-sort"></i></span>
                        </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let candi of selectedCandidates">
                    <td>{{ candi.firstName }} {{ candi?.lastName }}</td>
                    <td>{{ candi.nickName || "-" }}</td>
                    <td>{{ candi.gender == 'M' ? 'Male' : (candi.gender == 'F' ? 'Female' : '-') }}</td>
                    <td>{{ candi.mobile || "-" }}</td>
                    <td>{{ candi.email || "-" }}</td>
                    <td>{{ candi.customText20 || "-" }}</td>
                    <td>{{ candi.customDate1 | date: "dd-MM-yyy" }}</td>
                    <td>{{ candi.status || "-" }}</td>
                  </tr>
                </tbody>
              </table>
              <ng-template #noCandidates>
                <div *ngIf="!displayLoader">
                  <h5>No Candidates</h5>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>